import { Icon, Text } from '@kanda-libs/ks-design-library';
import type { FunctionComponent } from 'react';

export interface ListItem {
  header: string;
  content: string;
}

export interface NumberedListProps {
  list: ListItem[];
  bullets?: boolean;
  numberColor?: string;
  backgroundColor?: string;
  backgroundClassName?: string;
  headerTextClassName?: string;
  contentTextClassName?: string;
  isLoading?: boolean;
}

const NumberedList: FunctionComponent<NumberedListProps> = function ({
  list,
  bullets = false,
  numberColor = 'text-purple-500',
  backgroundColor = 'bg-purple-100',
  backgroundClassName = 'mt-px my-auto',
  headerTextClassName = 'text-16-24-em text-neutral-700',
  contentTextClassName = 'text-14-22 text-neutral-700',
  isLoading = false,
}) {
  return (
    <div className="flex flex-col gap-y-4 md:gap-y-6 w-full text-left">
      {list.map((item: ListItem, index: number) => (
        <div key={item.header} className="flex flex-row gap-x-5">
          <div
            className={`flex w-8 h-8 min-w-8 min-h-8 rounded-full ${backgroundColor} ${backgroundClassName}`}
          >
            {bullets ? (
              <Icon
                icon="check"
                stroke={numberColor}
                className={`m-auto ${numberColor}`}
                size={16}
                isLoading={isLoading}
              />
            ) : (
              <Text
                isLoading={isLoading}
                className="m-auto"
                text={
                  <p className={`text-18-22-em m-auto ${numberColor}`}>
                    {index + 1}
                  </p>
                }
              />
            )}
          </div>
          <div className="flex flex-col w-full">
            <Text
              isLoading={isLoading}
              text={<h2 className={headerTextClassName}>{item.header}</h2>}
              skeletonProps={{
                height: 24,
              }}
            />
            <Text
              isLoading={isLoading}
              text={<h3 className={contentTextClassName}>{item.content}</h3>}
            />
          </div>
        </div>
      ))}
    </div>
  );
};

export default NumberedList;
